import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'Water Level Monitoring Systems',
      description: 'Complete wireless water level monitoring for tanks, reservoirs, and sumps with intelligent alarm systems',
      features: ['Wireless 433-434 MHz technology', '500m communication range', 'Multi-level detection (20%-100%)', '10-year battery life'],
      image: '💧'
    },
    {
      title: 'Industrial Temperature Control',
      description: 'Professional wireless temperature monitoring for industrial applications with high precision sensors',
      features: ['Industrial-grade sensors', 'Wide temperature range', 'Wireless communication', 'Real-time monitoring'],
      image: '🏭'
    },
    {
      title: 'Smart Home Automation',
      description: 'Integrated monitoring solutions for residential water and temperature management systems',
      features: ['Home integration', 'Mobile app control', 'Energy efficiency', 'Smart notifications'],
      image: '🏠'
    },
    {
      title: 'Commercial Solutions',
      description: 'Comprehensive monitoring systems for commercial establishments and office buildings',
      features: ['Multi-zone monitoring', 'Central dashboard', 'Maintenance alerts', 'Cost optimization'],
      image: '🏢'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Smart Monitoring Services</h2>
          <p>Comprehensive wireless monitoring solutions for water level and temperature management across various applications</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" data-aos="fade-up" data-aos-delay={index * 150}>
              <div className="service-image">
                <span className="service-icon">{service.image}</span>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>
                      <span className="check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="service-footer">
                  <button className="btn btn-outline">Learn More</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cta-section">
          <div className="cta-content">
            <h3>Ready to Upgrade Your Monitoring Systems?</h3>
            <p>Contact us today for professional wireless monitoring solutions for water level and temperature management</p>
            <div className="cta-buttons">
              <button 
                className="btn btn-primary"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Contact Us
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Get Quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
